<template>
  <Dialog
    :custom-class="customClass"
    top=""
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    @close="close"
    @closed="closed"
    @open="open"
    @opened="opened"
  >
    <div class="pg-dialog-select-main__content" :style="{ height: contentHeight ?? 'auto' }">
      <div class="pg-dialog-select-main__content-left" v-if="!!treeData || typeTags.length > 0">
        <PgTabs
          v-if="typeTags.length > 0"
          class="pg-dialog-select-main-tag"
          v-model="activeTag"
          :hideHeader="typeTags.length === 1"
          @tab-click="switchTab"
        >
          <template v-for="item in typeTags">
            <PgTabPane
              class="pg-form-tag__tab"
              v-if="showTag(item)"
              :key="item.property"
              :label="item.label"
              :name="item.property"
              :lazy="item.parameter?.lazy ?? false"
            >
            </PgTabPane>
          </template>
        </PgTabs>
        <PgTree
          class="pg-dialog-select-main-tree"
          v-if="!!treeData"
          :treeDefaultProps="{
            defaultExpandAll: true,
          }"
          :filterKeys="treeFilterKeys"
          :parentNode="parentNode"
          :data="treeData"
          :currentNode="treeCurrent"
          @current-change="treeChange"
        ></PgTree>
      </div>
      <div class="pg-dialog-select-main__content-right">
        <alertMessage
          v-if="isShowAlertMessageOne"
          :formTopMessage="alertMessageInfoOne"
        ></alertMessage>
        <div class="pg-dialog-select-main__selects" v-if="multiple && selections?.length > 0">
          <span class="pg-dialog-select-main__selects-title">已选择：</span>
          <Tag
            class="pg-dialog-select-main__selects__tag"
            size="small"
            type="info"
            disableTransitions
            closable
            v-for="(item, index) in selections"
            :key="index"
            @close="removeTag(item)"
          >
            <span>{{ getValueByPath(item, showKey) }}</span>
          </Tag>
          <i
            class="ivu-icon-icon-pg-qk pg-dialog-select-main__selects-clear"
            @click="removeTagAll"
          ></i>
        </div>
        <div class="pg-dialog-select-main__seach" v-if="!criteriaCode">
          <PgInput
            ref="inputRef"
            prefix-icon="ivu-icon-icon-pg-serach"
            clearable
            :validateCustom="false"
            v-model="keyword"
            @input="keywordChange"
            :placeholder="seachPlaceholder"
          />
        </div>
        <PgCriteriaFormDrawer
          v-else
          class="pg-dialog-select-main__seachs"
          :formData="queryData"
          :formItems="queryForm"
          @clear="updateQueryData({})"
          @search="currentChange(1)"
        />
        <div v-if="isShowSelectPrice !== undefined" style="padding: 10px 0">
          <Checkbox :value="isShowSelectPrice" @input="setIsShowSelectPrice"
            >选择供应商时自动带入价格</Checkbox
          >
        </div>
        <alertMessage v-if="isShowAlertMessage" :formTopMessage="alertMessageInfo"></alertMessage>
        <PgTable
          class="pg-dialog-select-main__table"
          ref="pgTableRef"
          height="100%"
          autoResize
          :checkboxConfig="checkboxConfigData"
          :columnTableCode="columnTableCode"
          :column="column"
          :treeNode="treeNode"
          :seqShow="seqShow"
          :loading="loading"
          :isSelection="multiple && !emitAllData"
          :showPagination="!!pageSize"
          :pageSizes="pageSizes"
          @checkbox-change="checkboxChange"
          @checkbox-all="checkboxAll"
          @row-change="rowChange"
          @current-change="currentChange"
          @size-change="sizeChange"
        >
        </PgTable>
      </div>
    </div>
    <template #footer>
      <slot name="footer">
        <ElButton
          v-if="showCancel"
          class="pg-dialog-select-main__btn"
          round
          @click="handleCancel"
          :loading="sureLoading"
          >{{ cancelBtnText }}</ElButton
        >
        <ElButton
          v-if="multiple"
          class="pg-dialog-select-main__btn"
          type="primary"
          round
          @click="submit"
          :loading="sureLoading"
          :disabled="disabledSubmitFn ? disabledSubmitFn(data, selections) : false"
          >{{ sureBtnText }}</ElButton
        >

        <span v-else></span>
      </slot>
    </template>
  </Dialog>
</template>
<script>
export default {
  name: 'DialogSelectMain',
  //防止触发表单校验
  componentName: 'ElFormItem',
}
</script>
<script setup>
import { Dialog, Tag, Checkbox } from 'element-ui'
import { PgTable } from '../../table/index'
import { useDrawerPack } from '../../../hooks/index'
import { toRef, ref, shallowRef, provide, computed } from 'vue'
import {
  http,
  clone,
  setValueByPath,
  compileData,
  getValueByPath,
  getTreeExpandList,
} from '../../../utils/index'
import { debounce } from 'lodash-es'
import { getTreeNode, getChildNodeIds } from '../util/index'
import { PgCriteriaFormDrawer, useCriteriaQueryDrawer } from '../../criteria-form/index'
import { PgTree } from '../../tree/index'
import { PgTabs, PgTabPane } from '../../tabs/index'
import { usePrice } from '../hook/use-price'
import { useTemplate } from '../../../hooks/index'
const props = defineProps({
  checkboxConfig: Object,
  title: {
    type: String,
    default: '请选择',
  },
  isShowAlertMessage: {
    type: Boolean,
    default: false,
  },
  alertMessageInfo: {
    type: String,
  },
  showCancel: {
    type: Boolean,
    default: false,
  },
  isShowAlertMessageOne: {
    type: Boolean,
    default: false,
  },
  alertMessageInfoOne: {
    type: String,
  },
  seachPlaceholder: {
    type: String,
    default: '编码/名称',
  },
  modal: Boolean,
  appendToBody: {
    type: Boolean,
    default: false,
  },
  //分页参数-可切换每页显示多少条的选项
  pageSizes: Array,
  width: {
    type: String,
    default: '740px',
  },
  //弹窗的高度，可选值为70/80/90，代表占屏幕搞得的70%/80%/90%
  height: Number,
  contentHeight: String,
  visible: {
    type: Boolean,
    default: true,
  },
  treeUrl: String,
  treeUrlParam: Object,
  treeUrlMethod: {
    type: String,
    default: 'get',
  },
  parentNode: {
    type: Object,
    default: () => ({
      selected: true,
      checked: false,
      expand: true,
      disabled: false,
      id: 'all-id',
      parent: '.',
      code: undefined,
      lead: undefined,
      leaf: false,
      depth: 0,
      title: '全部',
      name_: null,
      name: '全部',
      label: '全部',
      displayName: null,
      children: [],
      organization: null,
    }),
  },
  treeFilterKeys: Array,
  //只允许点击全部和最末的节点
  treeKey: String,
  //当配置改属性时treeKey失效，点击父节点时将当前所有最末子节点的id传给后台
  treeKeys: {
    type: String,
    default: 'parameters.areaIds',
  },
  columnTableCode: String,
  column: {
    type: [Object, Array],
    default: null,
  },
  // 高级查询的url
  criteriaUrl: {
    type: String,
    default: 'rest/ezcomp/dict/criteria/fetch/',
  },
  //高级查询显示多少列
  criteriaColumn: {
    type: Number,
    default: 6,
  },
  // 高级查询的code
  criteriaCode: String,
  // 高级查询默认值
  defaultQueryParameters: Object,
  //是否启用树形选择，展开树形的按钮放置的字段property
  treeNode: [String],
  seqShow: {
    type: Boolean,
    default: false,
  },
  url: String,
  method: {
    type: String,
    default: 'post',
  },
  paramater: Object,
  keywordKey: {
    type: String,
    default: 'parameters.keyword',
  },
  multiple: Boolean,
  //选中项是否是对象
  valueIsObj: Boolean,
  // 单选结果返回数组
  valueIsArray: {
    type: Boolean,
    default: false,
  },
  selection: [Array, Object, String],
  //选中项的唯一值，当valueIsObj为true时直接返回查询接口返回的结构，否则返回查询接口返回的selectionKey对应的值
  selectionKey: {
    type: String,
    default: 'id',
  },
  //接口返回数据的唯一值，默认和selectionKey一样, 当多选的时候必须和selectionKey一样
  requestDataKey: String,
  showKey: {
    type: String,
    default: 'name',
  },
  //点击确定是否关闭弹窗
  buttonClose: Boolean,
  //每页获取数据条数，为0或不存在时表示不使用分页查询
  pageSize: Number,
  //初始搜索框的值
  initKeyword: String,
  // 为true的时候就不显示复选框，点确定的时候就把表格数据通过之前的方式方式抛出去
  emitAllData: Boolean,
  isShowSelectPrice: {
    type: Boolean,
    default: undefined,
  },
  // 将选择的数据保存在localStorge
  setLocalStorageSelectPrice: String,
  // 树-分类
  // {
  // 		"label": "自定义分类",
  // 		"visible": true,
  // 		"property": "CUSTOM_CATALOG_ONE", // 唯一值
  // 		"paramKey": "catalog" // 表格查询时配置的参数key
  // 	}
  typeTags: {
    type: Array,
    default: () => [],
  },
  typeTagsTreeParamKey: {
    type: String,
    default: 'usage',
  },
  cancelBtnText: {
    type: String,
    default: '取消',
  },
  sureBtnText: {
    type: String,
    default: '确定',
  },
  // 不勾选可点击【确认】，处理函数。返回 false 则不勾选也可点击【确认】，返回 true 则需要再判断是否有勾选，有勾选才可点击
  disabledSubmitFn: { type: Function },
})

const emit = defineEmits([
  'on-cancel',
  'update:visible',
  'close',
  'closed',
  'update:isShowSelectPrice',
])

const customClass = computed(() => {
  const str = `pg-dialog pg-dialog-select-main ${
    props.height ? `pg-dialog-select-main__${props.height}` : ''
  }`
  return str
})
// 表格内容数据
const data = shallowRef([])

const { showDrawer, onCancel, handleCancel, close, closed, closeDrawer } = useDrawerPack(
  toRef(props, 'visible'),
  emit
)
const { changeMainPrice } = usePrice(props)
//处理表格复选框是否支持勾选
const checkboxConfigData = computed(() => {
  const { enable, enableCompile, ...other } = props.checkboxConfig ?? {}
  const defaultConfig = { checkStrictly: true, checkField: 'checked' }
  if (enable) {
    defaultConfig.checkMethod = (row) =>
      compileData(`{{${enable}}}`, { row, selections: selections.value, ...enableCompile })
  }
  return { ...defaultConfig, ...other }
})

//获取树查询条件
const treeData = shallowRef(null)
const treeCurrent = shallowRef(props.parentNode ?? null)
const getTreeData = async () => {
  if (props.treeUrl) {
    const param = Object.assign(
      {},
      props.treeUrlParam,
      activeTag.value ? { [props.typeTagsTreeParamKey]: activeTag.value } : {}
    )
    const [res] = await http[props.treeUrlMethod](props.treeUrl, param)
    treeData.value = res?.data
  }
}
const treeChange = (data) => {
  if (props.treeKeys) {
    treeCurrent.value = data
    currentChange(1)
  } else if (props.treeKey && (!data.children || !data.code)) {
    treeCurrent.value = data
    currentChange(1)
  }
}

const setIsShowSelectPrice = (val) => {
  emit('update:isShowSelectPrice', val)
}

// 高级查询-表单
const { getCriteria, queryForm, queryData, setQueryForm, updateQueryData, setDefaultQuery } =
  useCriteriaQueryDrawer(
    props.criteriaUrl,
    props.criteriaCode,
    props.criteriaColumn,
    props.defaultQueryParameters
  )

const page = shallowRef({
  pageNo: 1,
  pageSize: props.pageSize,
  totalCount: 0,
})
const keyword = ref(props.initKeyword ?? '')
const pgTableRef = ref(null)
const loading = ref(false)
const getData = async (val = '') => {
  const param = clone(props.paramater) ?? {}
  if (page.value.pageSize) {
    param.pageNo = page.value.pageNo
    param.pageSize = page.value.pageSize
  }
  if (props.criteriaCode) {
    param.parameters = Object.assign({}, queryData.value, param.parameters ?? {})
  } else {
    setValueByPath(param, props.keywordKey, keyword.value)
  }
  if (props.treeUrl) {
    if (props.treeKeys) {
      const ids = getChildNodeIds(treeCurrent.value)
      setValueByPath(param, props.treeKeys, treeCurrent.value?.id === 'all-id' ? null : ids)
    } else {
      const id = treeCurrent.value?.id ?? null
      setValueByPath(param, props.treeKey, id === 'all-id' ? null : id)
    }
  }
  // 如果选择了分类
  if (activeTag.value) {
    const id = treeCurrent.value?.id ?? null
    let key = props.typeTags.filter((im) => im.property === activeTag.value)[0].paramKey
    setValueByPath(param.parameters, key, id === 'all-id' ? null : treeCurrent.value)
  }
  loading.value = true
  const [res] = await http[props.method](props.url, param)
  loading.value = false
  if (res && keyword.value === val) {
    await pgTableRef.value.loadDataAsync((tablePage) => {
      tablePage.pageNo = page.value.pageNo
      tablePage.pageSize = page.value.pageSize
      return res
    })
    if (props.treeNode) {
      setTimeout(() => {
        pgTableRef.value.setAllTreeExpand(true)
      })
    }
    data.value = res?.data ?? []
    return res?.data ?? []
  }

  data.value = []
  return []
}
const currentChange = async (pageNo) => {
  page.value.pageNo = pageNo
  const list = await getData(keyword.value)
  if (list.length > 0) setTableChecked(list, selections.value)
}
const sizeChange = async (pageSize) => {
  page.value.pageSize = pageSize
  const list = await getData(keyword.value)
  if (list.length > 0) setTableChecked(list, selections.value)
}
const keywordChange = debounce(async (val) => {
  page.value.pageNo = 1
  const list = await getData(val)
  if (list.length > 0) setTableChecked(list, selections.value)
}, 200)

const requestKey = computed(() => props.requestDataKey ?? props.selectionKey)
//设置表格选中
const selections = shallowRef([])
const setTableChecked = (list, selectArr, isObj = true) => {
  if (props.multiple && selectArr?.length > 0) {
    selections.value = selectArr.map(
      (im) =>
        getTreeNode(list, isObj ? getValueByPath(im, props.selectionKey) : im, requestKey.value) ??
        im
    )
    setTimeout(() => {
      pgTableRef.value.setCheckboxRow(selections.value, true)
    })
  } else if (!props.multiple && selectArr) {
    const row =
      getTreeNode(
        list,
        isObj
          ? getValueByPath(
              selectArr,
              selectArr === props.selection ? props.selectionKey : requestKey.value
            )
          : selectArr,
        requestKey.value
      ) ?? selectArr
    selections.value = props.valueIsArray ? [row] : row

    setTimeout(() => {
      pgTableRef.value.setCurrentRow(selections.value)
    })
  }
}
const open = async () => {
  if (props.treeUrl) {
    treeCurrent.value = props.parentNode ?? null
    getTreeData()
  }
  if (props.criteriaCode) {
    const [res, defaultQueryData] = await getCriteria()
    setQueryForm(res)
    setDefaultQuery(defaultQueryData)
  }
  keyword.value = props.initKeyword ?? ''
  selections.value = []
  page.value.pageNo = 1
  const list = await getData(keyword.value)
  if (list.length > 0) {
    setTableChecked(list, props.selection, props.valueIsObj)
  }

  if (props.isShowSelectPrice !== undefined) {
    emit('update:isShowSelectPrice', changeMainPrice())
  }
}
const inputRef = ref(null)
const opened = () => {
  inputRef.value?.focus()
}
const checkboxChange = ({ row, checked }) => {
  const rowList = getTreeExpandList([row])
  selections.value = checked
    ? [
        ...selections.value,
        ...rowList.filter(
          (im) =>
            !selections.value.some(
              (slIm) =>
                getValueByPath(im, props.selectionKey) === getValueByPath(slIm, props.selectionKey)
            )
        ),
      ]
    : selections.value.filter(
        (im) =>
          !rowList.some(
            (slIm) =>
              getValueByPath(im, props.selectionKey) === getValueByPath(slIm, props.selectionKey)
          )
      )
}
const checkboxAll = ({ allData, checked }) => {
  if (checked) {
    selections.value = [
      ...selections.value,
      ...allData.filter(
        (im) =>
          !selections.value.some(
            (slIm) =>
              getValueByPath(im, props.selectionKey) === getValueByPath(slIm, props.selectionKey)
          )
      ),
    ]
  } else {
    selections.value = selections.value.filter(
      (select) =>
        !allData.some(
          (im) =>
            getValueByPath(im, props.selectionKey) === getValueByPath(select, props.selectionKey)
        )
    )
  }
}
const rowChange = ({ row }) => {
  if (!props.multiple && !props.emitAllData) {
    selections.value = row
    submit()
  }
}
const removeTag = (item) => {
  selections.value = selections.value.filter(
    (im) => getValueByPath(im, props.selectionKey) !== getValueByPath(item, props.selectionKey)
  )
  setTimeout(() => {
    pgTableRef.value.setCheckboxRow(item, false)
  })
}
const removeTagAll = () => {
  selections.value = []
  pgTableRef.value.setAllCheckboxRow(false, true)
}

const sureLoading = ref(false)
const submit = () => {
  if (props.emitAllData) {
    emit('on-ok', pgTableRef.value.getTableData().fullData)
  } else {
    const notChild =
      props.multiple && checkboxConfigData.value?.checkStrictly === false
        ? selections.value.filter((im) => !im.children?.length)
        : selections.value
    const resData = props.multiple
      ? notChild.map((im) => (props.valueIsObj ? im : getValueByPath(im, props.selectionKey)))
      : props.valueIsObj
      ? notChild
      : getValueByPath(notChild, props.selectionKey)
    emit('on-ok', resData)
  }
  if (props.buttonClose) {
    closeDrawer()
  }
}

//处理在表单中必填时出现bug
provide('elFormItem', '')
provide('elForm', '')

//---------- typeTags 功能------------

const { getTemplateData } = useTemplate()
const compileSource = computed(() => ({
  data: props.paramater,
  ...props.defaultQueryParameters,
}))
const propsCompileData = getTemplateData(null, compileSource.value)

const showTag = (item) => {
  return item.visible && (!item.show || compileData(item.show, propsCompileData))
}

const activeTag = ref(props.typeTags.length > 0 ? props.typeTags[0].property : '')

const switchTab = (value) => {
  activeTag.value = value
  treeData.value = null
  getTreeData()
}
</script>

<style lang="scss">
@import '../slyle/main.scss';
</style>
